import * as React from 'react';
import { Controller, get, useFormContext } from 'react-hook-form';

import { MessageErrorField } from '../MessageErrorField';
import SelectField from '../fields/Select';
import { IBaseField, ISelectField } from '../types';

const SelectController: React.FunctionComponent<IBaseField & ISelectField> = (
  props,
) => {
  const { className, ...rest } = props;
  const { formState, control, getValues } = useFormContext();
  const error: { message?: string } = get(formState?.errors, rest.name);
  const { disabled, ...restDisabled } = rest;

  return (
    <Controller
      control={control}
      {...restDisabled}
      render={({ field }) => {
        field.value = getValues(rest.name);
        return (
          <>
            <SelectField
              {...field}
              {...rest}
              error={!!error}
            />
            <MessageErrorField message={error?.message} name={rest.name} />
          </>
        );
      }}
    />
  );
};

export default SelectController;
